import { FC, useState } from 'react'
import Spinner from 'react-bootstrap/Spinner'
import { useIntl } from 'react-intl'

import { PrinterAPI } from '@api/printerAPI'
import QueueNumbersAPI from '@api/queueNumbersAPI'

import { Tooltip } from '@components/Tooltip'

import { useToast } from '@/hooks'
import AxiosUtil from '@/utils/axiosUtil'

type Props = {
  queueNumber: string
}

const QueueNodeReprintButton: FC<Props> = ({ queueNumber }) => {
  const toast = useToast()
  const intl = useIntl()
  const [loading, setLoading] = useState<boolean>(false)

  const handleClick = async () => {
    try {
      setLoading(true)
      const { data } = await QueueNumbersAPI.reprint({ queue_number: queueNumber })
      if (data && data.printer_data) {
        await PrinterAPI.print(data.signature, data.printer_data)
      }
      toast.success(
        intl.formatMessage({
          id: 'queue_number.print.success',
        })
      )
    } catch (err) {
      if (AxiosUtil.isAxiosError(err) && err.response?.data.message) {
        toast.error(err.response.data.message)
      } else {
        toast.error(
          intl.formatMessage({
            id: 'queue_number.print.failed',
          })
        )
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <Tooltip
      text={intl.formatMessage({
        id: 'queue_number.reprint',
      })}
      placement="top"
    >
      <button
        type="button"
        className="btn btn-sm btn-icon btn-secondary"
        onClick={handleClick}
      >
        <div className="d-flex flex-column justify-content-center align-items-center">
          {loading ? (
            <Spinner
              animation="border"
              variant="dark"
              style={{ width: '1.5rem', height: '1.5rem' }}
            />
          ) : (
            <i className="fa fa-print fs-5" />
          )}
        </div>
      </button>
    </Tooltip>
  )
}

export { QueueNodeReprintButton }
